import React from 'react';

function QuizIntro({ introText, onStart }) {
    return (
        <div>
            <p className="quiz-intro-text">{introText}</p>
            <div className="quiz-intro-button-wrapper">
                <button className="btn" onClick={onStart}>Rozpocznij quiz</button>
            </div>
        </div>
    );
}

export default QuizIntro;
